import { FC, PropsWithChildren } from 'react';

import { FeatureFlag } from '@/shared/api/protocol-ts/model/dto_organization_pb';
import { useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';

import {
  FullHeadMprSlicesContext,
  useFullHeadMprSlicesRoot,
} from '../../hooks';

type FullHeadMprSlicesProviderProps = PropsWithChildren<{
  patientID: string;
  reportID: string;
  toothID: string;
}>;

const FullHeadMprSlicesActiveProvider: FC<FullHeadMprSlicesProviderProps> = (
  props,
) => {
  const { patientID, reportID, toothID, children } = props;

  const value = useFullHeadMprSlicesRoot({ patientID, reportID, toothID });

  return (
    <FullHeadMprSlicesContext.Provider value={value}>
      {children}
    </FullHeadMprSlicesContext.Provider>
  );
};

export const FullHeadMprSlicesProvider: FC<FullHeadMprSlicesProviderProps> = (
  props,
) => {
  const { patientID, reportID, toothID, children } = props;

  const isFullHeadMprEnabled = useAppSelector(
    organizationModel.selectors.selectFeatureFlag(
      FeatureFlag.FeatureFlag_Enable_FullHeadMPRs,
    ),
  );

  if (!isFullHeadMprEnabled) {
    return <>{children}</>;
  }

  return (
    <FullHeadMprSlicesActiveProvider
      patientID={patientID}
      reportID={reportID}
      toothID={toothID}
    >
      {children}
    </FullHeadMprSlicesActiveProvider>
  );
};
